import { mq,variables } from '../../../cssInJs'

export default {
    pageTiles__five: mq({
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginTop: '40px',
        marginBottom: '40px',
        gap: '2%',
        // Override the shared `.pageTile__big` width (23% ≈ 4/row) so tiles
        // sit 5 across from `lg` up. Breakpoints: [base, sm576, md768, lg992, xl1200, xxl1600].
        '.pageTile__big': {
            flex: 'none',
            width: ['100%', '48%', '48%', '18%', '18%', '18%'],
        },
    }),
    pageTile__big__wrapper: ({
        '&.green': {
            borderBottomColor: variables.greenColor,
            '&:hover, &:focus, &.selected': {
                backgroundColor: variables.greenColor,
                borderBottomColor: variables.greenColor,
            },
        },
        '&.tiffanyGreen': {
            borderBottomColor: variables.tiffanyGreenColor,           
            '&:hover, &:focus, &.selected': {
                backgroundColor: variables.tiffanyGreenColor,
                borderBottomColor: variables.tiffanyGreenColor
            },
        },
        '&.waterGreen': {
            borderBottomColor: variables.waterGreenColor,
            '&:hover, &:focus, &.selected': {
                backgroundColor: variables.waterGreenColor,
                borderBottomColor: variables.waterGreenColor
            },
        }
    }),
    pageTile__big__title: ({
        '&.green': {
            color: variables.greenColor
        },
        '&.tiffanyGreen': {
            color: variables.tiffanyGreenColor
        },
        '&.waterGreen': {
            color: variables.waterGreenColor
        }
    }),
    pageTile_btn: ({
        '&.green': {
            color: variables.greenColor
        },
        '&.tiffanyGreen': {
            color: variables.tiffanyGreenColor
        },
        '&.waterGreen': {
            color: variables.waterGreenColor
        }
    })
}